module.exports = __webpack_public_path__ + "img/img_2.bffb4fb0.png";